import React from "react"
import Image from "./Image"
import haris_bjelic from "../../images/haris_bjelic.jpg"

import Title from "./Title"
import Contacting from "./Contacting"
import SubTitle from "./SubTitle"
import ButtonIcon from "../ButtonIcon"
import ImageFluid from "../ImageFluid"
import theme from "../../themes"

const Contact = ({ image }) => {
  return (
    <div style={{ textAlign: "center" }}>
      <ImageFluid
        alt="Haris Bjelic"
        rounded
        width={"100%"}
        widthMd={"75%"}
        widthLg={"50%"}
        borderRadius={"50%"}
        fluid={image}
      />

      <Title center>Haris Bjelic</Title>
      <SubTitle center>Ihr Ansprechpartner</SubTitle>
      <Contacting />
    </div>
  )
}

export default Contact
